import { useMemo, useState } from "react";
import userPlaceholder from "assets/images/user-placeholder.png";
import { resolveProfilePhotoSrc } from "../../../functions";

interface GameHistoryUserAvatarProps {
	photo?: string | null;
	className: string;
}

export function GameHistoryUserAvatar({ photo, className }: GameHistoryUserAvatarProps) {
	const photoSrc = useMemo(() => resolveProfilePhotoSrc(photo), [photo]);
	const [failedPhoto, setFailedPhoto] = useState<string | null | undefined>(undefined);

	const src = failedPhoto === photo ? userPlaceholder : photoSrc;

	return (
		<div className={className}>
			<img
				src={src}
				alt=""
				className="discoverGameHistory-userAvatarImg"
				loading="lazy"
				onError={() => setFailedPhoto(photo)}
			/>
		</div>
	);
}
